(function(){
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  let drawerTrigger = null;
  function openDrawer(trigger){
    const drawer = $('.pk-drawer'); if(!drawer) return;
    drawerTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    const button = $('[data-drawer-open]'); if(button) button.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
    const close = $('[data-drawer-close]', drawer); if(close) close.focus();
  }
  function closeDrawer(){
    const drawer = $('.pk-drawer'); if(!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    const button = $('[data-drawer-open]'); if(button) button.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
    if(drawerTrigger && typeof drawerTrigger.focus === 'function') drawerTrigger.focus();
    drawerTrigger = null;
  }

  document.addEventListener('click', function(e){
    const openButton=e.target.closest('[data-drawer-open]'); if(openButton) openDrawer(openButton);
    if(e.target.closest('[data-drawer-close]') || e.target.classList.contains('pk-drawer__overlay')) closeDrawer();
    if(e.target.closest('[data-backtop]')) window.scrollTo({top:0,behavior:'smooth'});
  });

  document.addEventListener('keydown', function(e){
    const drawer=$('.pk-drawer');
    if(e.key==='Escape' && drawer && drawer.classList.contains('is-open')){ closeDrawer(); return; }
    if(e.key==='Tab' && drawer && drawer.classList.contains('is-open')){
      const focusable=$$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',drawer).filter(el=>!el.hidden && el.offsetParent!==null);
      if(!focusable.length)return;
      const first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
    }
  });

  $$('.pk-thumb').forEach(btn=>{
    btn.addEventListener('click', function(){
      const src = this.getAttribute('data-large-src');
      const alt = this.getAttribute('data-alt') || '';
      const img = $('[data-product-main-image]');
      if(img && src){ img.src = src; img.alt = alt; }
      $$('.pk-thumb').forEach(b=>b.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  $$('.pk-qty').forEach(qty=>{
    const input = $('input', qty);
    qty.addEventListener('click', e=>{
      const btn = e.target.closest('button'); if(!btn || !input) return;
      const current = parseInt(input.value || '1', 10) || 1;
      if(btn.dataset.qty === 'minus') input.value = Math.max(1, current - 1);
      if(btn.dataset.qty === 'plus') input.value = current + 1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  const productRoot = $('[data-product-root]');
  if(productRoot){
    let variants = [];
    try{ variants = JSON.parse($('[data-variants-json]', productRoot).textContent); }catch(e){}
    const currency = productRoot.getAttribute('data-currency') || 'GBP';
    const priceEl = $('[data-product-price]', productRoot);
    const idInput = $('[data-variant-id]', productRoot);
    const addBtn = $('[data-add-button]', productRoot);
    const stock = $('[data-stock-status]', productRoot);
    const oosHelp = $('[data-oos-help]', productRoot);
    const purchaseActions = $('[data-purchase-actions]', productRoot);
    const quantityControl = $('[data-quantity-control]', productRoot);
    const dynamicCheckout = $('[data-dynamic-checkout]', productRoot);
    const mainImage = $('[data-product-main-image]', productRoot);
    const formatter = new Intl.NumberFormat(undefined,{style:'currency',currency:currency});

    function selectedOptions(){
      const opts=[];
      $$('[data-option-position]', productRoot).forEach(group=>{
        const pos = parseInt(group.getAttribute('data-option-position'),10)-1;
        const checked = $('input:checked', group);
        if(checked) opts[pos] = checked.value;
      });
      return opts;
    }
    function setPurchaseState(variant){
      const available = !!(variant && variant.available);
      if(idInput) idInput.value = variant ? variant.id : '';
      if(priceEl && variant) priceEl.textContent = formatter.format(variant.price/100);
      if(addBtn){
        addBtn.disabled = !available;
        addBtn.textContent = available ? (addBtn.getAttribute('data-add-text') || 'Add to cart') : (addBtn.getAttribute('data-sold-text') || 'Unavailable');
      }
      const quantity = variant && Number(variant.inventory_quantity);
      const low = available && Number.isFinite(quantity) && quantity > 0 && quantity < 6;
      if(stock){
        stock.textContent = available ? (low ? (stock.getAttribute('data-low-stock') || 'A few left in stock!') : (stock.getAttribute('data-in-stock') || 'In stock')) : (stock.getAttribute('data-out-stock') || 'Out of stock');
        stock.classList.toggle('pk-stock--low', low);
        stock.classList.toggle('pk-stock--out', !available);
      }
      if(oosHelp) oosHelp.hidden = available;
      if(quantityControl) quantityControl.hidden = !available;
      if(dynamicCheckout) dynamicCheckout.hidden = !available;
      if(purchaseActions) purchaseActions.classList.toggle('pk-product-actions--unavailable', !available);
      const skuRow = $('[data-product-sku-row]', productRoot), sku = $('[data-product-sku]', productRoot);
      const barcodeRow = $('[data-product-barcode-row]', productRoot), barcode = $('[data-product-barcode]', productRoot);
      if(sku){ sku.textContent = variant && variant.sku || ''; if(skuRow) skuRow.hidden = !(variant && variant.sku); }
      if(barcode){ barcode.textContent = variant && variant.barcode || ''; if(barcodeRow) barcodeRow.hidden = !(variant && variant.barcode); }
      if(variant && variant.featured_image && variant.featured_image.src && mainImage){
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || mainImage.alt;
      }
      if(variant && window.history && window.history.replaceState){
        const next = new URL(window.location.href); next.searchParams.set('variant', variant.id); window.history.replaceState({},'',next.toString());
      }
    }
    function updateVariant(){
      const opts = selectedOptions();
      $$('[data-option-position]', productRoot).forEach(group=>{ const checked=$('input:checked',group), label=$('[data-option-selected]',group); if(label&&checked) label.textContent=checked.value; });
      const variant = variants.find(v => v.options && v.options.every((o,i)=>String(o)===String(opts[i])));
      setPurchaseState(variant || null);
    }
    $$('[data-option-position] input', productRoot).forEach(input=>input.addEventListener('change', updateVariant));
  }

  $$('.pk-countdown[data-end-date]').forEach(cd=>{
    const end = new Date(cd.getAttribute('data-end-date')).getTime();
    if(!end) return;
    const parts = {days:$('[data-days]',cd),hours:$('[data-hours]',cd),minutes:$('[data-minutes]',cd),seconds:$('[data-seconds]',cd)};
    function tick(){
      const diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff/86400000), h=Math.floor(diff/3600000)%24, m=Math.floor(diff/60000)%60, s=Math.floor(diff/1000)%60;
      if(parts.days) parts.days.textContent = String(d).padStart(2,'0');
      if(parts.hours) parts.hours.textContent = String(h).padStart(2,'0');
      if(parts.minutes) parts.minutes.textContent = String(m).padStart(2,'0');
      if(parts.seconds) parts.seconds.textContent = String(s).padStart(2,'0');
    }
    tick(); setInterval(tick,1000);
  });
})();

// BCO transparent homepage header: readable transparent at top, solid black on scroll
(function(){
  const header = document.querySelector('.pk-header-wrap');
  if(!header || !document.body.classList.contains('template-index')) return;
  const root = document.documentElement;
  const announcement = document.querySelector('.pk-announcement');
  function setAnnouncementHeight(){
    const h = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    root.style.setProperty('--bco-announcement-height', h + 'px');
  }
  const update = () => {
    setAnnouncementHeight();
    header.classList.toggle('is-scrolled', window.scrollY > 36);
  };
  update();
  window.addEventListener('resize', setAnnouncementHeight, { passive: true });
  window.addEventListener('scroll', update, { passive: true });
})();

// BCO desktop nav stability: keeps dropdown open while cursor moves into panel
(function(){
  const nav = document.querySelector('.pk-nav');
  if(!nav) return;
  const items = Array.from(nav.querySelectorAll('.pk-nav__item'));
  const timers = new WeakMap();

  function clearCloseTimer(item){
    const timer = timers.get(item);
    if(timer){ window.clearTimeout(timer); timers.delete(item); }
  }

  function setExpanded(item, expanded){
    const link = item.querySelector('.pk-nav__link');
    if(link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeItem(item){
    clearCloseTimer(item);
    item.classList.remove('bco-nav-open');
    setExpanded(item, false);
  }

  function closeAll(except){
    items.forEach((item) => { if(item !== except) closeItem(item); });
  }

  function openItem(item){
    if(!item || !item.querySelector('.pk-nav__dropdown')) return;
    clearCloseTimer(item);
    closeAll(item);
    item.classList.add('bco-nav-open');
    setExpanded(item, true);
  }

  function scheduleClose(item, delay){
    clearCloseTimer(item);
    timers.set(item, window.setTimeout(() => closeItem(item), delay || 520));
  }

  items.forEach((item) => {
    const dropdown = item.querySelector('.pk-nav__dropdown');
    const link = item.querySelector('.pk-nav__link');
    if(!dropdown || !link) return;

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    item.addEventListener('mouseenter', () => openItem(item));
    item.addEventListener('focusin', () => openItem(item));
    item.addEventListener('mouseleave', () => scheduleClose(item, 520));

    dropdown.addEventListener('mouseenter', () => openItem(item));
    dropdown.addEventListener('mouseleave', () => scheduleClose(item, 260));

    // Touch/coarse pointer support: first tap opens, second tap follows link.
    link.addEventListener('click', (event) => {
      if(!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
      if(!item.classList.contains('bco-nav-open')){
        event.preventDefault();
        openItem(item);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if(event.key === 'Escape') closeAll();
  });
  window.addEventListener('scroll', () => closeAll(), { passive:true });
})();


// BCO AJAX cart: keep customer on product/homepage, update visible cart count, and show a small cart notice.
(function(){
  var shopRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function route(path){ return shopRoot.replace(/\/?$/,'/')+String(path||'').replace(/^\//,''); }
  function ensureToast(){
    var toast = document.querySelector('.pk-cart-toast');
    if(toast) return toast;
    toast = document.createElement('div');
    toast.className = 'pk-cart-toast';
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    toast.innerHTML = '<strong>Added to cart</strong><p>Your item has been added. You can keep shopping or go to cart when ready.</p><div class="pk-cart-toast__actions"><a class="pk-cart-toast__view" href="'+route('cart')+'">View cart</a><a class="pk-cart-toast__checkout" href="'+route('checkout')+'">Checkout</a></div>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(){
    var toast = ensureToast();
    toast.classList.add('is-open');
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(function(){ toast.classList.remove('is-open'); }, 4500);
  }

  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count], .pk-cart-count').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  }

  function refreshCartCount(){
    return fetch(route('cart.js'), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if(cart && typeof cart.item_count !== 'undefined') updateCartCount(cart.item_count); return cart; })
      .catch(function(){ return null; });
  }

  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!form || !form.matches('form[action*="/cart/add"]')) return;
    if(form.dataset.bcoAjaxDisabled === 'true') return;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var originalText = button && button.tagName === 'BUTTON' ? button.textContent : null;
    var originalDisabled = button ? button.disabled : false;
    if(button){ button.disabled = true; if(originalText) button.textContent = 'Adding...'; }

    fetch(route('cart/add.js'), {
      method: 'POST',
      body: new FormData(form),
      headers: {'Accept':'application/json'}
    })
    .then(function(response){
      if(!response.ok) return response.json().then(function(data){ throw data; });
      return response.json();
    })
    .then(function(){ return refreshCartCount(); })
    .then(function(){ showToast(); })
    .catch(function(error){
      var message = error && (error.description || error.message) ? (error.description || error.message) : 'This item could not be added to cart. Please try again.';
      window.alert(message);
    })
    .finally(function(){
      if(button){ button.disabled = originalDisabled; if(originalText) button.textContent = originalText; }
    });
  }, true);

  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();

// BCO header overlap guard removed: desktop nav visibility is handled by CSS breakpoints so the main menu does not disappear unexpectedly.
